import Layout from '@/components/Layout';

export default [
  {
    path: '/reports',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'export',
      },
      {
        path: 'export',
        component: () => import('@/views/report/export'),
        name: 'exportReport',
        meta: {
          title: '数据报表',
          attachProject: true,
        },
      },
      {
        path: 'download',
        component: () => import('@/views/report'),
        name: 'downloadReport',
        meta: {
          title: '报表下载',
          attachProject: true,
        },
      },
    ],
  },
];
